/* TNZ Personalization v1: product metafield -> form properties -> cart/order. */
(() => {
  if (window.__tnzPersonalizationV1) { window.__tnzPersonalizationV1(); return; }
  const configurations = new Map();
  const values = new Map();
  const validators = new WeakMap();
  const fileCleanups = new Map();
  let formNumber = 0;
  let scheduled = false;
  const el = (tag, className) => { const node = document.createElement(tag); if (className) node.className = className; return node; };
  // File uploads must use Shopify's native multipart endpoint. Fetching that
  // endpoint preserves the binary files while keeping the product page open.
  const uploadOperations = new Map();
  async function submitPhotos(form, product) {
    const key = product.productId;
    if (uploadOperations.get(key)?.busy) return;
    const button = Array.from(document.querySelectorAll('button[type="submit"],input[type="submit"]')).find(node=>node.form===form);
    if (button?.disabled || button?.getAttribute('aria-disabled')==='true') return;
    const productForm = form.closest('product-form');
    const spinner = productForm?.querySelector('.loading__spinner') || form.querySelector('.loading__spinner');
    const previousDisabled = button?.getAttribute('aria-disabled');
    const root = window.Shopify?.routes?.root || '/';
    const cartUrl = `${root}cart`;
    const oldError = form.querySelector('.tnz-personalization__submit-error');oldError?.remove();
    productForm?.handleErrorMessage?.();
    const status = el('small','tnz-personalization__submit-status');status.setAttribute('role','status');status.textContent='Uploading photos…';form.querySelector('.tnz-personalization').append(status);
    const body = new FormData(form);
    let operation = uploadOperations.get(key);
    if (!operation) {
      operation = { token: crypto.randomUUID(), variant: String(body.get('id')), quantity: Number(body.get('quantity') || 1), fields: Array.from(form.querySelectorAll('input[data-tnz-file-slot]')).map(input=>input.name.slice(11,-1)), submitted: false, busy: false };
      uploadOperations.set(key,operation);
    }
    operation.busy = true;
    button?.setAttribute('aria-disabled','true');button?.setAttribute('aria-busy','true');button?.classList.add('loading');spinner?.classList.remove('hidden');
    try {
      if (!operation.submitted) {
        body.set('properties[_tnz_upload_request]',operation.token);
        const action = new URL(form.action,location.href);action.pathname=action.pathname.replace(/\.js\/?$/,'');
        if (action.origin!==location.origin || !/\/cart\/add\/?$/.test(action.pathname)) throw new Error('Invalid upload form. Please reload the product page.');
        operation.submitted = true;
        const response = await fetch(action.href,{method:'POST',body,credentials:'same-origin'});
        if (!response.ok) {
          if (response.status>=400 && response.status<500) {
            uploadOperations.delete(key);operation.submitted=false;
            let message='Could not add this product. Please review your options and try again.';
            if (response.headers.get('content-type')?.includes('application/json')) {const data=await response.json();if(typeof data.description==='string')message=data.description;}
            throw new Error(message);
          }
          throw new Error('Could not confirm the upload. Check your cart before trying again.');
        }
      }
      status.textContent='Checking your cart…';
      let cart;
      for (const suffix of ['.js','.json']) {
        try {const response=await fetch(`${cartUrl}${suffix}`,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});if(!response.ok)continue;const data=await response.json();if(Array.isArray(data.items)){cart=data;break;}} catch (_) { /* Try the alternate cart read endpoint; never repeat the add. */ }
      }
      if (!cart) throw new Error('Could not confirm the upload. Check your cart before trying again.');
      const item = cart.items?.find(line=>line.properties?._tnz_upload_request===operation.token && String(line.variant_id || line.id)===operation.variant);
      if (!item || item.quantity!==operation.quantity || !operation.fields.every(name=>typeof item.properties?.[name]==='string' && item.properties[name].includes('/uploads/'))) throw new Error('Could not confirm the uploaded photos. Check your cart before trying again.');
      uploadOperations.delete(key);
      if (productForm) productForm.error=false;
      try {if(typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined')Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate,{source:'product-form',productVariantId:operation.variant,cartData:item})).catch(()=>{});} catch (_) { /* Confirmation works independently of theme subscribers. */ }
      const event = new CustomEvent('gp:cart-added',{bubbles:true,cancelable:true,detail:{item,quantity:operation.quantity,opener:button}});
      if ((form.isConnected?form:document).dispatchEvent(event)) location.assign(cartUrl);
    } catch (error) {
      const message = el('div','tnz-personalization__submit-error');message.setAttribute('role','alert');
      message.append(document.createTextNode(operation.submitted?'Could not confirm the uploaded photos. Check your cart before trying again.':error.message || 'Could not upload photos. Please try again.'));
      if (operation.submitted) {const link=el('a');link.href=cartUrl;link.textContent='View cart';message.append(document.createTextNode(' '),link);}
      else uploadOperations.delete(key);
      form.querySelector('.tnz-personalization')?.append(message);
    } finally {
      operation.busy=false;status.remove();button?.classList.remove('loading');button?.removeAttribute('aria-busy');
      if(previousDisabled===null || previousDisabled===undefined)button?.removeAttribute('aria-disabled');else button?.setAttribute('aria-disabled',previousDisabled);
      spinner?.classList.add('hidden');
    }
  }
  function attach(form, product) {
    const existing = form.querySelector('.tnz-personalization');
    if (existing?.dataset.productId === product.productId) return;
    existing?.remove();
    const block = el('div', 'tnz-personalization');
    block.dataset.productId = product.productId;
    const variantLabel = document.querySelector('variant-selects input[type="radio"]:checked + label, .product-form__input--pill input[type="radio"]:checked + label');
    if (variantLabel) block.style.setProperty('--tnz-choice-accent', getComputedStyle(variantLabel).borderColor);
    const heading = el('h3'); heading.textContent = 'Personalization'; block.append(heading);
    const state = values.get(product.productId) || new Map(); values.set(product.productId, state);
    const checks = [];
    const prefix = `tnz-personal-${++formNumber}`;
    product.config.fields.forEach((field, index) => {
      if (!field.name || !['text','textarea','select','radio','checkbox','file'].includes(field.type)) return;
      const choices = Array.isArray(field.values) ? field.values : [];
      const property = `properties[${field.name}]`;
      const id = `${prefix}-${index}`;
      const wrapper = el('div', 'tnz-personalization__field');
      const grouped = ['select','radio','checkbox'].includes(field.type);
      const container = grouped ? el('fieldset') : wrapper;
      const label = el(grouped ? 'legend' : 'label');
      label.textContent = field.name + (field.required ? ' *' : '');
      if (!grouped) label.htmlFor = id;
      container.append(label);
      if (grouped) wrapper.append(container);
      const previous = state.get(field.name);
      if (field.type === 'file') {
        const maxFiles = Math.max(1,Math.min(10,Number(field.max_files)||5));
        const maxMb = Math.max(1,Math.min(10,Number(field.max_file_size_mb)||5));
        const picker = el('input');picker.type='file';picker.id=id;picker.accept='image/jpeg,image/png,image/webp';picker.multiple=maxFiles>1;picker.required=!!field.required;
        const pickerBox=el('div','tnz-personalization__picker');const pickerIcon=el('span','tnz-personalization__picker-icon');pickerIcon.setAttribute('aria-hidden','true');
        const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('width','24');svg.setAttribute('height','24');svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.8');svg.setAttribute('stroke-linecap','round');svg.setAttribute('stroke-linejoin','round');
        const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d','M12 16V4m-5 5 5-5 5 5M4 16v4h16v-4');svg.append(path);pickerIcon.append(svg);
        const pickerText=el('span','tnz-personalization__picker-text');pickerText.setAttribute('aria-hidden','true');pickerBox.append(pickerIcon,pickerText,picker);
        const help=el('small');help.id=id+'-help';help.textContent=`JPG, PNG, WebP · Up to ${maxFiles} photos · ${maxMb} MB each`;
        const error=el('small','tnz-personalization__upload-error');error.setAttribute('role','alert');
        const previews=el('div','tnz-personalization__uploads');const slots=el('div');slots.hidden=true;
        let files=Array.isArray(previous)?previous.filter(f=>f instanceof File):[];let message='';let urls=[];
        const release=()=>{urls.forEach(url=>URL.revokeObjectURL(url));urls=[];};
        const cleanups=fileCleanups.get(block)||[];cleanups.push(release);fileCleanups.set(block,cleanups);
        const validate=()=>{picker.setCustomValidity(message||(field.required&&!files.length?`Please upload ${field.name}.`:''));};
        const render=()=>{
          release();previews.replaceChildren();slots.replaceChildren();const selection=new DataTransfer();
          files.forEach((file,n)=>{
            selection.items.add(file);const slot=el('input');slot.type='file';slot.name=`properties[${field.name} ${n+1}]`;slot.dataset.tnzFileSlot='true';
            const single=new DataTransfer();single.items.add(file);slot.files=single.files;slots.append(slot);
            const item=el('div','tnz-personalization__upload');const photo=el('img');const url=URL.createObjectURL(file);urls.push(url);photo.src=url;photo.alt=file.name;
            const filename=el('span');filename.textContent=file.name;const remove=el('button');remove.type='button';remove.textContent='Remove';remove.setAttribute('aria-label',`Remove ${file.name}`);
            remove.addEventListener('click',()=>{files=files.filter((_,i)=>i!==n);message='';render();});item.append(photo,filename,remove);previews.append(item);
          });
          pickerText.textContent=files.length===1?files[0].name:files.length?`${files.length} photos selected`:'Upload photos';
          picker.files=selection.files;state.set(field.name,files);error.textContent=message;validate();
        };
        picker.addEventListener('change',()=>{
          const incoming=Array.from(picker.files||[]);
          if(!incoming.length){render();return;}
          if(files.length+incoming.length>maxFiles)message=`Select up to ${maxFiles} photos.`;
          else if(incoming.some(file=>!['image/jpeg','image/png','image/webp'].includes(file.type)))message='Please choose JPG, PNG or WebP images.';
          else if(incoming.some(file=>file.size===0||file.size>maxMb*1024*1024))message=`Each photo must be non-empty and no larger than ${maxMb} MB.`;
          else{files=[...files,...incoming];message='';}
          render();
        });
        picker.setAttribute('aria-describedby',help.id);container.append(pickerBox,help,error,previews,slots);
        if(field.instructions){const note=el('small');note.textContent=field.instructions;container.append(note);}
        render();checks.push(validate);
      } else if (grouped) {
        const controls = [];
        const hidden = field.type === 'checkbox' ? el('input') : null;
        if (hidden) { hidden.type = 'hidden'; hidden.name = property; container.append(hidden); }
        const choicesContainer = el('div', 'tnz-personalization__choices');container.append(choicesContainer);
        choices.forEach((choice, n) => {
          const row = el('label', 'tnz-personalization__choice');
          const input = el('input'); input.type = field.type === 'checkbox' ? 'checkbox' : 'radio'; input.id = `${id}-${n}`; input.value = choice;
          if (!hidden) { input.name = property; input.required = !!field.required; }
          input.checked = Array.isArray(previous) ? previous.includes(choice) : previous === choice;
          const text = el('span'); text.textContent = choice; row.append(input,text); choicesContainer.append(row); controls.push(input);
        });
        if (field.instructions) {
          const help = el('small');help.id = id+'-help';help.textContent = field.instructions;container.append(help);
          controls.forEach(input=>input.setAttribute('aria-describedby',help.id));
        }
        const sync = () => {
          const selected = controls.filter(c => c.checked).map(c => c.value);
          if (hidden) { hidden.value = selected.join(', '); hidden.disabled = !selected.length; state.set(field.name, selected); }
          else state.set(field.name, selected[0] || '');
          if (hidden && controls[0]) controls[0].setCustomValidity(field.required && !selected.length ? `Please choose ${field.name}.` : '');
        };
        controls.forEach(input => input.addEventListener('change',sync)); sync(); checks.push(sync);
      } else {
        const input = el('input');
        input.id = id; input.name = property; input.required = !!field.required;
        input.type = 'text';
        input.maxLength = Math.min(5000, Math.max(1, Number(field.max_length) || 100));
        input.value = typeof previous === 'string' ? previous : '';
        input.addEventListener('input',()=>state.set(field.name,input.value)); container.append(input);
        if (field.instructions) { const help = el('small'); help.id = id+'-help'; help.textContent = field.instructions; input.setAttribute('aria-describedby',help.id); container.append(help); }
        {
          const counter = el('small', 'tnz-personalization__counter');counter.id = id+'-count';
          const updateCount = () => { counter.textContent = `${input.value.length}/${input.maxLength}`; };
          input.addEventListener('input',updateCount);updateCount();container.append(counter);
          input.setAttribute('aria-describedby',[input.getAttribute('aria-describedby'),counter.id].filter(Boolean).join(' '));
        }
      }
      block.append(wrapper);
    });
    if (block.children.length === 1) return;
    validators.set(form,checks);
    form.prepend(block);
    // Themes frequently use novalidate and AJAX. Validate before their submit listeners run.
    if (!form.dataset.tnzPersonalizationValidated) {
      form.dataset.tnzPersonalizationValidated = 'true';
      form.addEventListener('submit',event => {
        if (!form.querySelector('.tnz-personalization')) return;
        (validators.get(form)||[]).forEach(check=>check());
        if (!form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        if (form.querySelector('input[data-tnz-file-slot]')) {
          event.preventDefault();event.stopImmediatePropagation();void submitPhotos(form,product);
        }
      }, true);
    }
  }
  function boot() {
    scheduled = false;
    for(const [block,cleanups] of fileCleanups)if(!block.isConnected){cleanups.forEach(cleanup=>cleanup());fileCleanups.delete(block);}
    document.querySelectorAll('script[data-tnz-personalization-config]').forEach(script => {
      try { const config = JSON.parse(script.dataset.config || script.textContent); if (config.productId && Array.isArray(config.variantIds) && config.config?.version === 1 && Array.isArray(config.config.fields)) configurations.set(config.productId,config); } catch (_) { /* Other theme scripts remain independent. */ }
    });
    document.querySelectorAll('form[action]').forEach(form => {
      if (form.dataset.tnzCustomPreview === 'true') return;
      let url; try { url = new URL(form.action,location.href); } catch (_) { return; }
      if (!/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) return;
      // Dawn also renders a product form for payment terms beside the price.
      // Its /cart/add action and variant ID do not make it an add-to-cart form.
      const installment = form.matches('.installment, [id^="product-form-installment-"]');
      const purchase = form.matches('[data-type="add-to-cart-form"]') ||
        Array.from(document.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])')).some(button => button.form === form);
      if (installment || !purchase) { form.querySelector('.tnz-personalization')?.remove(); return; }
      const variant = form.querySelector('[name="id"]')?.value;
      for (const product of configurations.values()) if (product.variantIds.map(String).includes(String(variant))) { attach(form,product); break; }
    });
  }
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(boot); } };
  window.__tnzPersonalizationV1 = schedule;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',schedule);
})();
